
import GwSection from '~/patterns/organisms/section/section.vue';
import ImageSingle from '~/patterns/atoms/image-single/image-single.vue';

export default {
    components: {
        GwSection,
        ImageSingle
    },

    props: {
        image: {
            type: Array,
            required: true,
            default: () => { return []; },
            // validator: imageObject => imageObject[0] && imageObject[0].w1260
        },

        caption: {
            type: String,
            required: false,
            default: ''
        },

        heading: {
            type: String,
            required: false,
            default: null
        },

        width: {
            type: String,
            required: false,
            default: 'content'
        }
    },

    computed: {
        hasImage() {
            return this.image && this.image[0];
        }
    }
};
